module.exports = __webpack_public_path__ + "static/vmware_15.4c9e1add.jpg";